export default __webpack_public_path__ + "static/media/MilestoneLogo.51b8cf72.svg";